import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {MagicSquareComponent} from 'app/tool-layer/tools/magic-square/magic-square.component';
import {ComponentModule} from 'app/component/component.module';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [MagicSquareComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(MagicSquareComponent),
            multi: true,
        },
    ],
})
export class MagicSquareModule {}
